import React, { Component } from 'react';
import axios from 'axios';
import { type RouteComponentProps } from 'react-router-dom';

interface userprops extends RouteComponentProps {}

class Registration extends Component<userprops, {}> {
  state = {
    username: 'sony.sadi',
    email: 'sony.sadi@gmail.com',
    password: '12345678',
    errorMessage: '',
    user: {},
  };

  componentDidMount() {
    const myURL = new URL(window.location.href);
    myURL.searchParams.forEach((value, name, searchParams) => {
      if (name === 'confirmation') {
        this.setState({ confirmation: value });
        this.confirmEmail(value);
      }
    });
  }

  render() {
    return (
      <div className="d-md-flex half">
        <div className="bg" style={{ backgroundImage: 'url("/images/bg_1.jpg")' }}></div>
        <div className="contents">
          <div className="container">
            <div className="row align-items-center justify-content-center">
              <div className="col-md-12">
                <div className="form-block mx-auto">
                  <div className="text-center mb-5">Confirming Email</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  confirmEmail = async (code: string) => {
    await axios
      .get(`${process.env.REACT_APP_API_SERVER}/auth/email-confirmation?confirmation=${code}`)
      .then((res) => {
        if (res.status === 200) {
          this.props.history.push('/dashboard');
        }
      })
      .catch((error) => {
        if (error.response) {
          console.error(error.response);
        }
      });
  };
}

export default Registration;
